import { DocumentNode, gql } from "@apollo/client";

class TestHistoryService {
  public static getTestHistoryCards = (): DocumentNode => gql`
    query GetTestHistoryCards(
      $limit: Float
      $offset: Float
      $sort: String
      $from: String
      $to: String
    ) {
      getTestHistoryCards(
        limit: $limit
        offset: $offset
        sort: $sort
        from: $from
        to: $to
      ) {
        tests {
          uid
          orderUidPublic
          testType
          status
          nextStatus
          managedBy
          sampleType
          sampleReceivedDate
          PTPOption
          viewStatus
          organType
          isProReach
          createdAt
          trackingNumber
          reportGender
          caPnsSupplemental
          resultCode
          resultReleasedAt
          cancelledAt
          latestResultDocumentUid
          clinic {
            limsId
          }
          primaryAction
          i18nKeys {
            title
            statusText
            description
            secondaryStatusText
            primaryAction
            nextStatus
            bottomLine
            params {
              date
              estimatedResultsDate
              sampleCollectionDate
              sampleReceivedDate
            }
          }
          clinicalInfo {
            __typename
            ... on SignateraClinicalInfo {
              cancerType
              dateOfSurgery
            }
            ... on AlteraClinicalInfo {
              cancerType
              dateOfSurgery
            }
            ... on LatitudeClinicalInfo {
              cancerType
              dateOfSurgery
            }
          }
        }
        total
      }
    }
  `;
}

export default TestHistoryService;
